/**
 * ContentCard - A reusable card component with consistent styling
 * 
 * Props:
 * - children: Content to render inside the card
 * - className: Additional CSS classes to apply
 * - style: Additional inline styles to apply
 * - noPadding: If true, removes default padding
 */
function ContentCard({ children, className = "", style = {}, noPadding = false }) {
  const cardClass = `content-card ${noPadding ? "content-card--no-padding" : ""} ${className}`.trim();

  return (
    <div className={cardClass} style={style}>
      {children}
    </div>
  );
}

export default ContentCard;

